var React = require('react');

function FrontendNavigationIntegrate (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M11 4v-4h-11v11h4v5h12v-12h-5zM10 6.125h-4v-0.125h4v0.125zM10 10h-4v-0.125h4v0.125zM10 9.625h-4v-0.25h4v0.25zM10 9.125h-4v-0.25h4v0.25zM10 8.625h-4v-0.25h4v0.25zM10 8.125h-4v-0.25h4v0.25zM10 7.625h-4v-0.25h4v0.25zM10 7.125h-4v-0.25h4v0.25zM10 6.625h-4v-0.25h4v0.25zM4 10h-3v-9h9v3h-6v6zM15 15h-10v-3h7v-7h3v10z"}));
}

FrontendNavigationIntegrate.displayName = "FrontendNavigationIntegrate";

FrontendNavigationIntegrate.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendNavigationIntegrate;

FrontendNavigationIntegrate.default = FrontendNavigationIntegrate;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-navigation-integrate.svg
// module id = 1003
// module chunks = 0